import { render, staticRenderFns } from "./affix.vue?vue&type=template&id=12a95bc5"
import script from "./affix.vue?vue&type=script&lang=js"
export * from "./affix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports